import React from 'react';

import { useAuthentication } from '@pkg/hooks';

import { YAT_PICKER } from '@app/routes/paths';

import { CreateButton, LoginButton, Text, TextWrapper, Title, Wrapper } from './Sidebar.style';

export function Sidebar() {
    const { handleAuthenticate } = useAuthentication();

    return (
        <Wrapper>
            <LoginButton onClick={(event) => handleAuthenticate(event)}>Log in</LoginButton>

            <TextWrapper>
                <Title>BE AN ICON</Title>
                <Text>Your Yat is your universal emoji username, website URL, payment address, and more.</Text>
            </TextWrapper>

            <CreateButton to={YAT_PICKER}>Create your Yat</CreateButton>
        </Wrapper>
    );
}
